var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      staticClass: "ui-icon",
      class: [_vm.iconSet, _vm.icon, { "is-mirrored": _vm.mirror }],
      attrs: { "aria-label": _vm.ariaLabel },
    },
    [
      _vm.useSvg
        ? _c("svg", [
            _c("use", {
              attrs: {
                "xmlns:xlink": "http://www.w3.org/1999/xlink",
                "xlink:href": "#" + _vm.icon,
              },
            }),
          ])
        : _vm._t("default", function () {
            return [_vm._v(_vm._s(_vm.removeText ? null : _vm.icon))]
          }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }